import type { LevelThreeProgressItem } from '@lemonade-hq/uniclient-chat';
import { Flex } from '@lemonade-hq/uniclient-theme';
import { motion } from 'motion/react';
import { getAnimationState } from '../animationHelpers';
import { textVariants } from '../animations';
import { LEVEL_TWO_GAP } from '../constants';
import type { AnimationProgressProps, BaseProgressItemProps } from '../types';
import { ItemContainer } from './common/ItemContainer';
import { ItemContentWrapper } from './common/ItemContentWrapper';
import { ItemTitle } from './common/ItemTitle';

export interface ProgressSubSubItemProps
  extends BaseProgressItemProps,
    Pick<AnimationProgressProps, 'isBackwards' | 'isExpanding'> {
  readonly item: LevelThreeProgressItem;
  readonly isFirstRender: boolean;
  readonly isFirst?: boolean;
}

export const ProgressSubSubItem: React.FC<ProgressSubSubItemProps> = ({
  item,
  completed,
  current,
  isExpanding = false,
  isFirst,
  isFirstRender,
  isBackwards,
}) => {
  const subSubTextVariants = textVariants({ level: 3, isExpanding, isBackwards });

  return (
    <ItemContainer style={{ marginBlockStart: isFirst ? LEVEL_TWO_GAP : 0 }}>
      <Flex width="100%">
        <Flex
          animate={getAnimationState(completed, current)}
          as={motion.div}
          initial={!isFirstRender}
          variants={subSubTextVariants}
          width="100%"
        >
          <ItemContentWrapper isFirstRender={isFirstRender}>
            <ItemTitle
              completed={completed}
              current={current}
              isBackwards={isBackwards}
              isExpanding={isExpanding}
              level={3}
              title={item.title}
              type="bodySmall"
            />
          </ItemContentWrapper>
        </Flex>
      </Flex>
    </ItemContainer>
  );
};
